export default __webpack_public_path__ + "static/logoclear-70c133234fe655e9c1335f4ef809df3b.svg";